import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import PasswordReset from "./pages/PasswordReset";
import ConfirmPassword from "./pages/ConfirmPassword";

import MieterDashboard from "./pages/MieterDashboard";
import Einstellungen from "./pages/Einstellungen";
import PDFListPage from "./pages/PDFListPage";
import ZählerDetails from "./pages/ZählerDetails";

import AdminDashboardPage from "./pages/AdminDashboardPage";
import UploadPdfsPage from "./pages/UploadPdfsPage";
import CreateMieterPage from "./pages/CreateMieterPage";
import AdminEmailPage from "./pages/AdminEmailPage";
import MieterDetailsPage from "./pages/MieterDetailsPage";

import MieterLayout from "./components/MieterLayout";
import AdminLayout from "./components/AdminLayout";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/reset-password/:uid/:token" element={<ConfirmPassword />} />

        {/* 🏠 Mieter Routes */}
        <Route path="/mieter/:mieterId" element={<MieterLayout />}>
          <Route index element={<MieterDashboard />} />
          <Route path="einstellungen" element={<Einstellungen />} />
          <Route path="betriebskostenabrechnungen" element={<PDFListPage />} />
          <Route path="zaehler/:zaehlernummer" element={<ZählerDetails />} />
        </Route>

        {/* 🛠️ Admin Routes */}
        <Route path="/admin/:superUserId" element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="pdfUploads" element={<UploadPdfsPage />} />
          <Route path="neuerMieter" element={<CreateMieterPage />} />
          <Route path="sendMail" element={<AdminEmailPage />} />
          <Route path=":mieterId/:mietername" element={<MieterDetailsPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
